/**
 * Custom @xyflow/react node for KG visualization.
 * Renders a colored circle with caption label.
 */

import { memo } from 'react'
import { Handle, Position, type NodeProps } from '@xyflow/react'
import type { KgFlowNodeData } from './useSpiralLayout'

function KgFlowNodeComponent({ data, selected }: NodeProps & { data: KgFlowNodeData }) {
  const nodeData = data as KgFlowNodeData
  const diameter = Math.max(nodeData.size * 1.5, 24)

  return (
    <>
      <Handle type="target" position={Position.Top} className="!w-0 !h-0 !border-0 !bg-transparent" />
      <div className="flex flex-col items-center gap-1">
        <div
          className={`rounded-full transition-all ${
            selected || nodeData.selected
              ? 'ring-2 ring-blue-400 ring-offset-2 ring-offset-white dark:ring-offset-gray-950'
              : ''
          }`}
          style={{
            width: diameter,
            height: diameter,
            backgroundColor: nodeData.color,
            opacity: 0.9,
          }}
        />
        <span className="text-[10px] font-medium text-gray-700 dark:text-gray-300 max-w-[100px] truncate text-center leading-tight">
          {nodeData.caption}
        </span>
      </div>
      <Handle type="source" position={Position.Bottom} className="!w-0 !h-0 !border-0 !bg-transparent" />
    </>
  )
}

export const KgFlowNode = memo(KgFlowNodeComponent)
